import React from 'react';
import PropTypes from 'prop-types';
import { ChevronIconLeft, ChevronIconRight } from 'AppSrc/core/components/common/svg-icons';
import { VFDropdownBase } from '../forms/form-base-components/v-f-dropdown-base';

const PageSelect = ({
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  // create select options for pages 1 to totalPages
  const pageOptions = [];
  for (let i = 1; i <= totalPages; i++) {
    pageOptions.push({ text: `${i}`, value: `${i}` });
  }
  return (
    <VFDropdownBase
      displayOptions={pageOptions}
      updateValue={(pageStr) => setCurrentPage(Number(pageStr))}
      value={`${currentPage}`}
      noClear
    />
  );
};

const sharedPropTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
};

PageSelect.propTypes = {
  ...sharedPropTypes,
  totalPages: PropTypes.number,
};

const PaginationControls = ({
  totalRows,
  currentPage,
  rowsPerPage,
  setCurrentPage,
}) => {
  const nextPage = currentPage + 1;
  const prevPage = currentPage - 1;
  const hasPrev = prevPage > 0;
  const hasNext = (currentPage * rowsPerPage) < totalRows;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  return (
    <div className="pagination-controls">
      <div className="next-prev">
        <button
          type="button"
          onClick={() => setCurrentPage(prevPage)}
          disabled={!hasPrev}
        >
          <ChevronIconLeft />
        </button>
        <button
          type="button"
          onClick={() => setCurrentPage(nextPage)}
          disabled={!hasNext}
        >
          <ChevronIconRight />
        </button>
      </div>
      <div className="page-select">
        Page
        <PageSelect
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
        {`of ${totalPages}`}
      </div>
    </div>
  );
};

PaginationControls.propTypes = {
  ...sharedPropTypes,
  totalRows: PropTypes.number,
  rowsPerPage: PropTypes.number,
};

export { PaginationControls };
